const state = {
  loading: false,
  logs: [],
  users: [],
  invoiceEligibleSettings: {
    enabled: false,
    title: 'New eligible invoice available',
    body: 'A new invoice has been uploaded and some items are eligible for an active campaign. Open HOYA E-Surprise to check your rewards.'
  },
  message: '',
  alertVariant: 'success',
  showDismissibleAlert: false
}

const mutations = {
  setLoading: function (state, loading) {
    state.loading = loading
  },
  setLogs: function (state, logs) {
    state.logs = logs
  },
  setUsers: function (state, users) {
    state.users = users
  },
  setInvoiceEligibleSettings: function (state, settings) {
    state.invoiceEligibleSettings = Object.assign({}, state.invoiceEligibleSettings, settings)
  },
  showAlert: function (state, payload) {
    state.message = payload.message
    state.alertVariant = payload.variant
    state.showDismissibleAlert = true
  },
  closeDismissibleAlert: function (state, dismiss) {
    state.showDismissibleAlert = dismiss
  }
}

const getters = {
  userFields: function () {
    return [
      { key: 'companyName', label: 'Company', sortable: true },
      { key: 'accountNumber', label: 'Customer Account', sortable: true },
      { key: 'email', label: 'Email', sortable: true },
      { key: 'phoneNumber', label: 'Phone', sortable: true },
      { key: 'status', label: 'Status', sortable: true }
    ]
  },
  logFields: function () {
    return [
      { key: 'createdDate', sortable: true },
      { key: 'title', sortable: true },
      { key: 'blast', sortable: true },
      { key: 'successCount', sortable: true },
      { key: 'failureCount', sortable: true },
      { key: 'status', sortable: true },
      { key: 'details', label: 'Details' }
    ]
  }
}

const actions = {
  fetchUsers: function (context) {
    context.commit('setLoading', true)
    context.rootState.firestoreDB.collection('users')
      .orderBy('email')
      .get()
      .then(function (querySnapshot) {
        let users = []
        querySnapshot.forEach(function (doc) {
          let data = doc.data()
          users.push({
            docId: doc.id,
            companyName: data.companyName || data.name || '',
            accountNumber: data.accountNumber || data.customerAccount || '',
            email: data.email || doc.id,
            phoneNumber: data.phoneNumber || '',
            status: data.status || '',
            approved: data.approved === true
          })
        })
        context.commit('setUsers', users)
        context.commit('setLoading', false)
      }).catch(function (err) {
        context.commit('setLoading', false)
        context.commit('showAlert', { variant: 'danger', message: 'Error loading users: ' + err.message })
      })
  },
  fetchInvoiceEligibleSettings: function (context) {
    context.rootState.firestoreDB.collection('configuration').doc('invoiceEligibleNotification')
      .get()
      .then(function (doc) {
        if (!doc.exists) {
          return
        }
        let data = doc.data()
        context.commit('setInvoiceEligibleSettings', {
          enabled: data.enabled === true,
          title: data.title || '',
          body: data.body || ''
        })
      }).catch(function (err) {
        context.commit('showAlert', { variant: 'danger', message: 'Error loading invoice notification settings: ' + err.message })
      })
  },
  saveInvoiceEligibleSettings: function (context, settings) {
    context.commit('setLoading', true)
    let currentUser = context.rootState.firebase.auth().currentUser
    let payload = {
      enabled: settings.enabled === true,
      title: settings.title || '',
      body: settings.body || '',
      updatedBy: currentUser ? currentUser.email : '',
      updatedDate: new Date()
    }

    context.rootState.firestoreDB.collection('configuration').doc('invoiceEligibleNotification')
      .set(payload, { merge: true })
      .then(function () {
        context.commit('setInvoiceEligibleSettings', payload)
        context.commit('setLoading', false)
        context.commit('showAlert', { variant: 'success', message: 'Invoice notification settings saved.' })
      }).catch(function (err) {
        context.commit('setLoading', false)
        context.commit('showAlert', { variant: 'danger', message: 'Error saving invoice notification settings: ' + err.message })
      })
  },
  sendNotification: function (context, payload) {
    context.commit('setLoading', true)
    let currentUser = context.rootState.firebase.auth().currentUser
    if (!currentUser) {
      context.commit('setLoading', false)
      context.commit('showAlert', { variant: 'danger', message: 'Please login again before sending notifications.' })
      return
    }

    currentUser.getIdToken(true).then(function (idToken) {
      let projectId = context.rootState.firebase.app().options.projectId
      let cloudFunctionUrl = 'https://asia-southeast1-' + projectId + '.cloudfunctions.net/sendCustomerNotification'
      let xmlHttp = new XMLHttpRequest()
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
          context.commit('setLoading', false)
          if (xmlHttp.status === 200) {
            context.commit('showAlert', { variant: 'success', message: 'Notification sent: ' + xmlHttp.responseText })
            context.dispatch('fetchLogs')
          } else {
            context.commit('showAlert', { variant: 'danger', message: 'Notification failed: ' + xmlHttp.responseText })
          }
        }
      }
      xmlHttp.open('POST', cloudFunctionUrl, true)
      xmlHttp.setRequestHeader('Content-Type', 'application/json')
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + idToken)
      xmlHttp.send(JSON.stringify(payload))
    }).catch(function (err) {
      context.commit('setLoading', false)
      context.commit('showAlert', { variant: 'danger', message: err.message })
    })
  },
  fetchLogs: function (context) {
    context.commit('setLoading', true)
    context.rootState.firestoreDB.collection('notificationLogs')
      .orderBy('createdDate', 'desc')
      .limit(100)
      .get()
      .then(function (querySnapshot) {
        let logs = []
        querySnapshot.forEach(function (doc) {
          let data = doc.data()
          data.docId = doc.id
          if (data.createdDate && data.createdDate.toDate) {
            data.createdDate = data.createdDate.toDate().toLocaleString()
          }
          data.recipients = data.blast ? 'Blast' : (Array.isArray(data.emails) ? data.emails.join(', ') : '')
          data.body = data.body || data.message || ''
          data.responses = Array.isArray(data.responses) ? data.responses : []
          logs.push(data)
        })
        context.commit('setLogs', logs)
        context.commit('setLoading', false)
      }).catch(function (err) {
        context.commit('setLoading', false)
        context.commit('showAlert', { variant: 'danger', message: err.message })
      })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/notificationsstoremodule.js